__turbopack_context__.v({
  "header": "no-results-module-scss-module__Kpp7qG__header",
  "noResultsContainer": "no-results-module-scss-module__Kpp7qG__noResultsContainer",
  "support": "no-results-module-scss-module__Kpp7qG__support",
  "tips": "no-results-module-scss-module__Kpp7qG__tips",
  "title": "no-results-module-scss-module__Kpp7qG__title",
});
